import { useState, useEffect, useRef, useMemo } from 'react'
import {
    Grid,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Card,
    ListItemButton,
    ListItemText,
    Chip,
    List,
    Collapse,
    Pagination,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material'
import { ArrowBackIos, ExpandLess, ExpandMore } from '@mui/icons-material'
import { Mantenciones, Inspecciones } from './ReportsListLeft'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCircle,
    faClipboardList,
    faCalendar,
    faDownload,
    faPlus,
    faInfoCircle,
    faMapMarker,
    faChartBar,
    faTrash,
    faReply,
    faFolderOpen
} from '@fortawesome/free-solid-svg-icons'
import './reports.css'
import { ReportsList } from '../../containers'
import { useNavigate } from 'react-router-dom'
import {
    useAuth,
    useReportsContext,
    useSitesContext,
    useUser,
    useStatus
} from '../../context'
import * as XLSX from 'xlsx'
import {
    ReportsResumeDialog,
    BulkActionDialog,
    SpmDocumentsDialog
} from '../../dialogs'
import SeleccionarObraDialog from '../../dialogs/SeleccionarObraDialog'
import ReportsKPIDialog from '../../dialogs/ReportsKPIDialog'
import { descargarDataCompilada } from '../../routes/databaseConnection.routes'
import { reportsRoutes } from '../../routes'

let cachedReportsPage = 1
let cachedReportsTipo = null
let cachedReportsSubFilter = null
let cachedReportsOpenAccordion = null
let cachedTipoReporteSeleccionado = null

const ReportsPage = () => {
    const { sites } = useSitesContext()
    const {
        admin,
        isSuperAdmin,
        isOperator,
        isSapExecutive,
        isShiftManager,
        isChiefMachinery,
        isOperatorInspector,
        isObserver,
        isUniversalInspector,
        isUniversalChief
    } = useUser()
    const { setstatus } = useStatus()
    const { userData } = useAuth()
    const {
        numerosEnReportes,
        reports,
        setListSelected,
        listSelected,
        listSelectedCache,
        getReports,
        statusReports,
        pautas,
        siteSelected,
        borrarListaReportes,
        reportesSeleccionados,
        reportsToShow,
        valueFilter,
        setValueFilter,
        tipoReporteSeleccionado,
        setTipoReporteSeleccionado,
        filtroReporte,
        refreshNumbers,
        sortField,
        sortOrder,
        reloadCurrentPage,
        changeToOrigen,
        removeReportFromReportsToShow,
        totalReportsList
    } = useReportsContext()
    const [inspecciones, setInspecciones] = useState([])
    const [mantenciones, setMantenciones] = useState([])
    const [hableCreateReport, setHableCreateReport] = useState(false)
    const [reportesPorPagina, setReportesPorPagina] = useState(10)
    const [totalPaginas, setTotalPaginas] = useState(0)
    const [pagina, setPaginaState] = useState(cachedReportsPage || 1)
    const setPagina = (val) => {
        const nextVal = typeof val === 'function' ? val(pagina) : val
        setPaginaState(nextVal)
        cachedReportsPage = nextVal
    }
    const [listToShow, setListToShow] = useState([])
    const [listToShowCache, setListToShowCache] = useState([])
    const [totalItems, setTotalItems] = useState(0)
    const [selectedReports, setSelectedReports] = useState(new Map())

    const allItemsSelected = useMemo(() => {
        return (
            listToShowCache.length > 0 &&
			listToShowCache.every((r) => selectedReports.has(r._id))
        )
    }, [listToShowCache, selectedReports])

    const isMoveToOrigenDisabled = useMemo(() => {
        if (selectedReports.size === 0) return true
        return !Array.from(selectedReports.values()).some(
            (report) =>
                (report.state === 'Asignar' || report.estado === 'Asignar') &&
				!report.origen
        )
    }, [selectedReports])

    const isDeleteDisabled = useMemo(() => {
        return selectedReports.size === 0
    }, [selectedReports])

    const [site, setSite] = useState('nada')
    const navigate = useNavigate()
    const [canOpenNewReport, setCanOpenNewReport] = useState(false)
    const [openReportSumary, setOpenReportSumary] = useState(false)
    const [openSeleccionarObra, setOpnSeleccionarObra] = useState(false)
    const [opnKPI, setOpnKPI] = useState(false)
    const [siteObject, setSiteObject] = useState()
    const [tipo, setTipoState] = useState(
        cachedReportsTipo || (isUniversalChief ? 'Inspección' : 'todos')
    )
    const setTipo = (val) => {
        const nextVal = typeof val === 'function' ? val(tipo) : val
        setTipoState(nextVal)
        cachedReportsTipo = nextVal
    }

    const [subFilter, setSubFilterState] = useState(cachedReportsSubFilter || null)
    const setSubFilter = (val) => {
        const nextVal = typeof val === 'function' ? val(subFilter) : val
        setSubFilterState(nextVal)
        cachedReportsSubFilter = nextVal
    }

    const [openAccordion, setOpenAccordionState] = useState(cachedReportsOpenAccordion || null)
    const setOpenAccordion = (val) => {
        const nextVal = typeof val === 'function' ? val(openAccordion) : val
        setOpenAccordionState(nextVal)
        cachedReportsOpenAccordion = nextVal
    }

    const [tipoDeSeleccion, setTipoDeSeleccion] = useState('global')
    const [tipoDeBusqueda, setTipoDeBusqueda] = useState('')
    const abortControllerRef = useRef(null)
    const debounceTimerRef = useRef(null)

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [openMoveDialog, setOpenMoveDialog] = useState(false)
    const [openSpmDocuments, setOpenSpmDocuments] = useState(false)

    useEffect(() => {
        if (cachedTipoReporteSeleccionado && tipoReporteSeleccionado !== cachedTipoReporteSeleccionado) {
            setTipoReporteSeleccionado(cachedTipoReporteSeleccionado)
        }
    }, [])

    useEffect(() => {
        if (subFilter && [
            'Ejecutando por operador',
            'Reasignar',
            'Revisión Supervisor',
            'Revisión J. Maquinaria'
        ].includes(subFilter)) {
            const expectedAccordion = `${tipo || 'Mantención'}-En proceso`
            setOpenAccordion(expectedAccordion)
        }
    }, [subFilter, tipo])

    const prevSortRef = useRef({ sortField, sortOrder })
    useEffect(() => {
        if (
            prevSortRef.current.sortField !== sortField ||
            prevSortRef.current.sortOrder !== sortOrder
        ) {
            setPagina(1)
        }
        prevSortRef.current = { sortField, sortOrder }
    }, [sortField, sortOrder])

    useEffect(() => {
        if (isUniversalChief) {
            setTipoReporteSeleccionado('all')
        }
    }, [isUniversalChief, setTipoReporteSeleccionado])

    useEffect(() => {
        if (numerosEnReportes && tipoReporteSeleccionado && tipo) {
            const category = tipo === 'Inspección' ? 'inspecciones' : 'mantenciones'

            // Map UI state names to numbersEnReportes keys
            const mapStateToKey = (s) => {
                if (s === 'Asignar') return 'asignar'
                if (s === 'En proceso') return 'enProceso'
                if (s === 'Por cerrar') return 'porCerrar'
                if (s === 'Completadas') return 'completadas'
                if (s === 'Origen') return 'origen'
                return s
            }

            const key = mapStateToKey(tipoReporteSeleccionado)
            const count = numerosEnReportes[category]?.[key]

            const isSearchActive = valueFilter.trim().length > 0 && tipoDeBusqueda !== ''

            if (count !== undefined && !isSearchActive) {
                setTotalItems(count)
                setTotalPaginas(Math.ceil(count / reportesPorPagina))
            }
        }
    }, [
        numerosEnReportes,
        tipoReporteSeleccionado,
        tipo,
        reportesPorPagina,
        valueFilter,
        tipoDeBusqueda
    ])

    const handleListClick = (item, tipo) => {
        const accordionId = `${tipo}-${item.name}`

        setOpenAccordion((prev) => (prev === accordionId ? null : accordionId))
        refreshNumbers()
        setSubFilter(null)

        if (tipoReporteSeleccionado !== item.name) {
            setSelectedReports(new Map())
        }

        setTipoDeBusqueda('')

        setPagina(1)
        setTipoReporteSeleccionado(item.name)
        cachedTipoReporteSeleccionado = item.name
        setReportesPorPagina(10)
        setTotalItems(item.number)
        setTotalPaginas(Math.ceil(item.number / 10))
        setTipo(tipo)
    }

    useEffect(() => {
        if (sites.length > 0 && siteSelected) {
            const sId =
				typeof siteSelected === 'object'
				    ? siteSelected._id || siteSelected.idobra
				    : siteSelected
            if (sId === 'all') {
                setSiteObject({
                    _id: 'all',
                    idObra: 'none',
                    descripcion: 'Todas las obras'
                })
                if ((admin || isSuperAdmin) && !cachedReportsTipo) {
                    setTipo('todos')
                }
            } else if (sId === 'universal') {
                setSiteObject({
                    _id: 'universal',
                    idObra: 'universal',
                    descripcion: 'REPORTES UNIVERSALES'
                })
                setTipo('Inspección')
                setTipoReporteSeleccionado('all')
            } else {
                const siteFiltered = sites.find(
                    (site) => site._id === sId || site.idobra === sId
                )
                setSiteObject(siteFiltered)
                if ((admin || isSuperAdmin) && !cachedReportsTipo) {
                    setTipo('todos')
                }
            }
        }
    }, [siteSelected, sites, admin, isSuperAdmin, setTipoReporteSeleccionado])

    useEffect(() => {
        if (pautas.length === 0) {
            setCanOpenNewReport(false)
        } else {
            setCanOpenNewReport(true)
        }
    }, [pautas])

    useEffect(() => {
        if (admin || isSapExecutive || isOperatorInspector) {
            setHableCreateReport(true)
        }
    }, [admin, isSapExecutive, isOperatorInspector])

    useEffect(() => {
        if (reportsToShow && reportsToShow.length > 0) {
            let filteredReports = reportsToShow
            const isUniversalSelected = siteSelected && (siteSelected._id === 'universal' || siteSelected === 'universal')
            const isUniversalChiefOrUniversalSelected = isUniversalChief || isUniversalSelected
            const isSearchingGlobal = tipoDeSeleccion === 'global' && valueFilter.trim().length > 0 && tipoDeBusqueda !== ''

            if (!isSearchingGlobal && isUniversalChiefOrUniversalSelected && tipoReporteSeleccionado === 'all') {
                filteredReports = reportsToShow.filter((report) => {
                    const level = report.level || 0
                    return level === 0 || level === 2
                })
            }

            let mappedList = filteredReports.map((report) => {
                report.estado = levelToState(
                    report.level,
                    report.usersAssigned,
                    report.state
                )
                report.checked = selectedReports.has(report._id)
                return report
            })

            if (subFilter && !isSearchingGlobal) {
                mappedList = mappedList.filter((r) => r.estado === subFilter)
            }

            setListToShow(mappedList)
            setListToShowCache(mappedList)
        } else {
            setListToShow([])
            setListToShowCache([])
        }
    }, [reportsToShow, subFilter, selectedReports, isUniversalChief, tipoReporteSeleccionado, siteSelected, tipoDeSeleccion, valueFilter, tipoDeBusqueda])

    useEffect(() => {
        if (tipoReporteSeleccionado === 'all') {
            const count = listToShow.length
            setTotalItems(count)
            setTotalPaginas(Math.ceil(count / reportesPorPagina))
        }
    }, [listToShow, tipoReporteSeleccionado, reportesPorPagina])

    useEffect(() => {
        if (numerosEnReportes) {
            console.log('[ReportsV2] Received numerosEnReportes:', numerosEnReportes)

            const inspeccionesTable = Inspecciones.map((item) => ({ ...item }))
            inspeccionesTable[0].number = numerosEnReportes.inspecciones.completadas
            inspeccionesTable[1].number = numerosEnReportes.inspecciones.porCerrar
            inspeccionesTable[2].number = numerosEnReportes.inspecciones.enProceso
            inspeccionesTable[3].number = numerosEnReportes.inspecciones.asignar
            inspeccionesTable[4].number = numerosEnReportes.inspecciones.origen
            inspeccionesTable[0].lista = []
            inspeccionesTable[1].lista = []
            inspeccionesTable[2].lista = [
                {
                    'Ejecutando por operador':
						numerosEnReportes.inspecciones['Ejecutando por operador']
                },
                { Reasignar: numerosEnReportes.inspecciones.Reasignar },
                {
                    'Revisión Supervisor':
						numerosEnReportes.inspecciones['Revisión Supervisor']
                },
                {
                    'Revisión J. Maquinaria':
						numerosEnReportes.inspecciones['Revisión J. Maquinaria']
                }
            ]
            inspeccionesTable[3].lista = []
            inspeccionesTable[4].lista = []
            setInspecciones(inspeccionesTable)

            const mantencionesTable = Mantenciones.map((item) => ({ ...item }))
            mantencionesTable[0].number = numerosEnReportes.mantenciones.completadas
            mantencionesTable[1].number = numerosEnReportes.mantenciones.porCerrar
            mantencionesTable[2].number = numerosEnReportes.mantenciones.enProceso
            mantencionesTable[3].number = numerosEnReportes.mantenciones.asignar
            mantencionesTable[4].number = numerosEnReportes.mantenciones.origen
            mantencionesTable[0].lista = []
            mantencionesTable[1].lista = []
            mantencionesTable[2].lista = [
                {
                    'Ejecutando por operador':
						numerosEnReportes.mantenciones['Ejecutando por operador']
                },
                { Reasignar: numerosEnReportes.mantenciones.Reasignar },
                {
                    'Revisión Supervisor':
						numerosEnReportes.mantenciones['Revisión Supervisor']
                },
                {
                    'Revisión J. Maquinaria':
						numerosEnReportes.mantenciones['Revisión J. Maquinaria']
                }
            ]
            mantencionesTable[3].lista = []
            mantencionesTable[4].lista = []
            setMantenciones(mantencionesTable)
        } else {
            console.log(
                '[ReportsV2] numerosEnReportes is null, resetting counts to 0.'
            )
            const inspeccionesTable = Inspecciones.map((item) => ({
                ...item,
                number: 0
            }))
            setInspecciones(inspeccionesTable)

            const mantencionesTable = Mantenciones.map((item) => ({
                ...item,
                number: 0
            }))
            setMantenciones(mantencionesTable)
        }
    }, [numerosEnReportes])

    useEffect(() => {
        const val = valueFilter.trim()
        if (val.length > 0 && tipoDeBusqueda !== '') {
            buscarReportesFiltrados(val)
        } else {
            if (tipoReporteSeleccionado && tipo) {
                const numeroInicialPagina = (pagina - 1) * reportesPorPagina
                reportesSeleccionados(
                    tipoReporteSeleccionado,
                    numeroInicialPagina,
                    reportesPorPagina,
                    tipo,
                    sortField,
                    sortOrder
                )
            }
        }
    }, [
        pagina,
        tipoReporteSeleccionado,
        reportesPorPagina,
        valueFilter,
        tipo,
        tipoDeBusqueda,
        tipoDeSeleccion,
        siteSelected,
        sortField,
        sortOrder
    ])

    const buscarReportesFiltrados = async (value) => {
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
        if (abortControllerRef.current) abortControllerRef.current.abort()

        abortControllerRef.current = new AbortController()

        debounceTimerRef.current = setTimeout(async () => {
            try {
                const numeroInicialPagina = (pagina - 1) * reportesPorPagina
                const valueToSearch = value

                if (
                    tipoDeBusqueda === 'idIndex' &&
					valueToSearch !== '' &&
					!/^\d+$/.test(valueToSearch)
                )
                { return }

                console.log('[ReportsV2] Executing search filter for:', valueToSearch)
                const isGlobalSearch = tipoDeSeleccion === 'global'
                const estadoToSend = isGlobalSearch ? '' : (subFilter || tipoReporteSeleccionado)
                const tipoToSend = isGlobalSearch ? '' : tipo

                const { numeroItems } = await filtroReporte(
                    estadoToSend,
                    numeroInicialPagina,
                    reportesPorPagina,
                    tipoToSend,
                    isGlobalSearch,
                    valueToSearch,
                    tipoDeBusqueda,
                    sortField || 'endReport',
                    sortOrder || -1,
                    abortControllerRef.current.signal
                )

                if (numeroItems !== null) {
                    setTotalPaginas(Math.ceil(numeroItems / reportesPorPagina))
                    setTotalItems(numeroItems)
                }
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Error en búsqueda:', err)
                }
            }
        }, 500)
    }

    const compareNumbers = (a, b) => {
        return b.idIndex - a.idIndex
    }

    const handleSelectAllItems = (checked) => {
        setSelectedReports((prev) => {
            let next = new Map(prev)
            if (checked) {
                let activeState = null
                if (prev.size > 0) {
                    activeState = Array.from(prev.values())[0]?.estado
                } else if (listToShowCache.length > 0) {
                    activeState = listToShowCache[0]?.estado
                }

                // If the first item on the page has a different state than the active state,
                // we clear the old selection (user switched context).
                if (
                    activeState &&
					listToShowCache.length > 0 &&
					listToShowCache[0]?.estado !== activeState
                ) {
                    next = new Map()
                    activeState = listToShowCache[0]?.estado
                }

                listToShowCache.forEach((report) => {
                    if (report.estado === activeState) {
                        next.set(report._id, report)
                    }
                })
            } else {
                // Deselect all items from the current page
                listToShowCache.forEach((report) => {
                    next.delete(report._id)
                })
            }
            return next
        })
    }

    const selectItem = (e, index) => {
        const report = listToShowCache[index]
        if (!report) return

        setSelectedReports((prev) => {
            let next = new Map(prev)
            if (e.target.checked) {
                // If there's already items in selection, check if the state matches.
                if (prev.size > 0) {
                    const existingState = Array.from(prev.values())[0]?.estado
                    if (report.estado !== existingState) {
                        // Clear previous selection since it's a different state/type
                        next = new Map()
                    }
                }
                next.set(report._id, report)
            } else {
                next.delete(report._id)
            }
            return next
        })
    }

    const handleRemoveSelectedReport = (reportId) => {
        setSelectedReports((prev) => {
            const next = new Map(prev)
            next.delete(reportId)
            return next
        })
    }

    const deleteSelected = async () => {
        if (selectedReports.size === 0) {
            setstatus({
                status: 'error',
                title: 'Selección vacía',
                message: 'Debe seleccionar al menos un reporte para eliminar.',
                severity: 'warning'
            })
        } else {
            setOpenDeleteDialog(true)
        }
    }

    const confirmDelete = async (deleteMode = 'logical') => {
        setOpenDeleteDialog(false)
        const ids = Array.from(selectedReports.keys())

        try {
            setstatus({
                status: 'generating',
                title: 'Eliminando Reportes',
                message: `Eliminando ${ids.length} reporte(s)...`,
                severity: 'info'
            })

            if (deleteMode === 'deleted') {
                for (const id of ids) {
                    await reportsRoutes.editReport({ _id: id, deleted: true })
                }
            } else {
                await borrarListaReportes(ids)
            }

            const isSearching = !!(valueFilter && valueFilter.trim() !== '')
            if (isSearching) {
                ids.forEach(id => removeReportFromReportsToShow(id))
            } else {
                await reloadCurrentPage()
            }

            setSelectedReports(new Map())
            setPagina(1)

            setstatus({
                status: 'completed',
                title: 'Reportes Eliminados',
                message: `${ids.length} reporte(s) eliminados correctamente}.`,
                severity: 'success'
            })
        } catch (error) {
            console.error('Error al eliminar reportes:', error)
            setstatus({
                status: 'error',
                title: 'Error al Eliminar',
                message:
					'Hubo un error al intentar eliminar los reportes seleccionados.',
                severity: 'error'
            })
        }
    }

    const textoFiltrado = (value) => {
        const listaCache = [...listSelectedCache]
        if (value.length > 0) {
            const lista = []
            listaCache.forEach((element, index) => {
                if (
                    element.idIndex.toString().match(Number(value).toString()) ||
					element.maquina.model.match(value) ||
					element.maquina.equ.match(value) ||
					element.sapId.match(value)
                ) {
                    if (site === 'nada') {
                        lista.push(element)
                    } else {
                        if (admin && element.idobra === site) {
                            lista.push(element)
                        }
                    }
                }
                if (index === listaCache.length - 1) {
                    setListSelected(lista.sort(compareNumbers))
                    setTotalItems(lista.length)
                }
            })
        } else {
            setListSelected(listSelectedCache.sort(compareNumbers))
            setTotalItems(listSelected.length)
        }
    }

    useEffect(() => {
        const listaCache = [...listSelectedCache]
        if (site === 'nada') {
            setListSelected(listSelectedCache)
            setTotalItems(listSelectedCache.length)
        } else {
            const lista = []
            listaCache.forEach((element, index) => {
                if (element.site === site) {
                    lista.push(element)
                }
                if (index === listaCache.length - 1) {
                    setListSelected(lista)
                    setTotalItems(lista.length)
                }
            })
        }
    }, [site])

    const downloadFile = async () => {
        downloadReports2()
    }

    const downloadReports2 = async () => {
        const dataCompilada = await descargarDataCompilada()
        if (dataCompilada.state) {
            const workbook = XLSX.utils.book_new()
            const worksheet = XLSX.utils.json_to_sheet(
                dataCompilada.data['Datos de reporte']
            )
            const datosMaterial = XLSX.utils.json_to_sheet(
                dataCompilada.data['Datos de material']
            )
            const datosTareasPendientes = XLSX.utils.json_to_sheet(
                dataCompilada.data['Datos de tareas pendientes']
            )
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos de reporte')
            XLSX.utils.book_append_sheet(
                workbook,
                datosMaterial,
                'Datos de material'
            )
            XLSX.utils.book_append_sheet(
                workbook,
                datosTareasPendientes,
                'Datos de tareas pendientes'
            )
            XLSX.writeFile(workbook, `${Date.now()}.xlsx`)
        } else {
            alert('Datos no pueden ser descargados en este momento.')
        }
    }

    const openToReportSumary = () => {
        setOpenReportSumary(true)
    }

    const closeToReportSumary = () => {
        setOpenReportSumary(false)
    }

    const closeSeleccionarObra = () => {
        setOpnSeleccionarObra(false)
    }

    const closeKPI = () => {
        setOpnKPI(false)
    }

    const handleMoveToOrigen = async () => {
        const selectedReportsArray = Array.from(selectedReports.values())
        const asignarReports = selectedReportsArray.filter(
            (report) =>
                (report.state === 'Asignar' || report.estado === 'Asignar') &&
				!report.origen
        )
        const selectedIds = asignarReports.map((item) => item._id)

        if (selectedIds.length === 0) {
            setstatus({
                status: 'error',
                title: 'Selección vacía',
                message:
					'Debe seleccionar al menos un reporte en estado "Asignar" para mover a Origen.',
                severity: 'warning'
            })
            return
        }

        await changeToOrigen(selectedIds)
        const isSearching = !!(valueFilter && valueFilter.trim() !== '')
        if (!isSearching) {
            reloadCurrentPage()
        }

        setSelectedReports((prev) => {
            const next = new Map(prev)
            selectedIds.forEach((id) => next.delete(id))
            return next
        })
        setPagina(1)
    }

    const levelToState = (level, usersAssigned, state) => {
        if (level === 0 || !level) {
            if (usersAssigned && usersAssigned.length > 0) {
                if (state === 'En proceso') {
                    return 'Ejecutando por operador'
                }
                return 'Reasignar'
            } else {
                return state === 'Reasignar' ? 'Reasignar' : 'Asignar'
            }
        } else if (level === 1) {
            return 'Revisión Supervisor'
        } else if (level === 2) {
            return 'Revisión J. Maquinaria'
        } else if (level === 3) {
            return 'Revisión SAP'
        } else if (level === 4) {
            return 'Completada'
        }
    }

    const filterState = (key, type, item, number) => {
        refreshNumbers()
        setTipoDeBusqueda('')

        setSubFilter(key)

        if (tipoReporteSeleccionado !== key) {
            setListToShow([])
            setListToShowCache([])
            setSelectedReports(new Map())
        }

        // Reset to standard pagination size to avoid loading all items
        const standardPageSize = 10
        setReportesPorPagina(standardPageSize)

        setPagina(1)
        setTipoReporteSeleccionado(key)
        cachedTipoReporteSeleccionado = key
        setTotalItems(number)
        setTotalPaginas(Math.ceil(number / standardPageSize))
        setTipo(
            type === 'inspeccion'
                ? 'Inspección'
                : type === 'mantencion'
                    ? 'Mantención'
                    : 'todos'
        )
    }

    const isSearchingGlobal =
        tipoDeSeleccion === 'global' &&
        valueFilter.trim().length > 0 &&
        tipoDeBusqueda !== ''

    return (
        <Box height="100%">
            {openSeleccionarObra && (
                <SeleccionarObraDialog
                    open={openSeleccionarObra}
                    handleClose={closeSeleccionarObra}
                />
            )}
            {opnKPI && (
                <ReportsKPIDialog
                    open={opnKPI}
                    handleClose={closeKPI}
                    reports={listToShow}
                />
            )}
            {openReportSumary && (
                <ReportsResumeDialog
                    open={openReportSumary}
                    handleClose={closeToReportSumary}
                    reports={reports}
                />
            )}
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={'pageCard'} style={{ overflowY: 'hidden' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <div className="navigation-bar">
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                        color: '#333',
                                        backgroundColor: '#fff',
                                        borderRadius: 20
                                    }}
                                >
                                    <Toolbar
                                        style={{
                                            paddingLeft: 0,
                                            backgroundColor: '#F9F9F9',
                                            borderRadius: 10
                                        }}
                                    >
                                        <IconButton
                                            onClick={() =>
                                                setTimeout(() => {
                                                    navigate('/welcome')
                                                }, 500)
                                            }
                                        >
                                            <ArrowBackIos style={{ color: '#333', fontSize: 16 }} />
                                        </IconButton>
                                        <Typography
                                            variant="h1"
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 0,
                                                fontSize: 16,
                                                whiteSpace: 'nowrap',
                                                marginRight: 20
                                            }}
                                        >
											Ordenes de trabajo
                                        </Typography>
                                        <div style={{ flexGrow: 1 }} />
                                        {(admin ||
											isSapExecutive ||
											isShiftManager ||
											isChiefMachinery ||
											isOperatorInspector ||
											isObserver ||
											isUniversalInspector ||
											isUniversalChief) && (
                                            <div style={{ width: 450, marginRight: 15 }}>
                                                <Grid
                                                    style={{ position: 'relative', width: '100%' }}
                                                    container
                                                >
                                                    <Grid item xs={4}>
                                                        <div style={{ padding: '0px 5px' }}>
                                                            <select
                                                                value={tipoDeSeleccion}
                                                                onChange={(e) => {
                                                                    setTipoDeSeleccion(e.target.value)
                                                                }}
                                                                style={{ height: 24, width: '100%' }}
                                                                placeholder="Tipo Selección"
                                                            >
                                                                <option value={'global'}>Global</option>
                                                                <option value={'listaSeleccionada'}>
																	Lista Seleccionada
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div style={{ padding: '0px 5px' }}>
                                                            <select
                                                                disabled={tipoDeSeleccion.length === 0}
                                                                value={tipoDeBusqueda}
                                                                onChange={(e) => {
                                                                    setTipoDeBusqueda(e.target.value)
                                                                }}
                                                                style={{ height: 24, width: '100%' }}
                                                                placeholder="Tipo Selección"
                                                            >
                                                                <option value="">Tipo Búsqueda</option>
                                                                <option value={'idIndex'}>N° OT</option>
                                                                <option value={'maquina'}>Maquina</option>
                                                                <option value={'sap'}>SAP ID</option>
                                                            </select>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <input
                                                            disabled={tipoDeBusqueda.length === 0}
                                                            style={{ height: 24, width: '100%' }}
                                                            value={valueFilter}
                                                            onChange={(e) => {
                                                                const val = e.target.value
                                                                setValueFilter(val)
                                                                setPagina(1)
                                                            }}
                                                            placeholder="Filtrar Reporte"
                                                            type="search"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        )}
                                        {admin &&
											tipoReporteSeleccionado !== 'Origen' &&
											subFilter !== 'Origen' && (
                                            <IconButton
                                                color={'primary'}
                                                style={{ marginRight: 5 }}
                                                edge={'end'}
                                                hidden={!hableCreateReport}
                                                onClick={() => setOpenMoveDialog(true)}
                                                disabled={isMoveToOrigenDisabled}
                                                title="Mover a Origen"
                                            >
                                                <FontAwesomeIcon icon={faReply} />
                                            </IconButton>
                                        )}
                                        {admin && (
                                            <IconButton
                                                color={'primary'}
                                                style={{ marginRight: 5 }}
                                                edge={'end'}
                                                hidden={!hableCreateReport}
                                                onClick={() => deleteSelected()}
                                                disabled={isDeleteDisabled}
                                                title="Borrar OT Seleccionada"
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </IconButton>
                                        )}
                                        <div
                                            style={{
                                                width: '1px',
                                                height: '24px',
                                                backgroundColor: '#ccc',
                                                margin: '0 15px',
                                                display: 'inline-block',
                                                alignSelf: 'center'
                                            }}
                                        />
                                        {(admin ||
											isUniversalInspector ||
											isUniversalChief ||
											(userData?.obras && userData.obras.length > 1)) && (
                                            <IconButton
                                                color={'primary'}
                                                style={{ marginRight: 5 }}
                                                edge={'end'}
                                                hidden={!hableCreateReport}
                                                onClick={() => setOpnSeleccionarObra(true)}
                                                title="Seleccionar Obra"
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }}>
                                                    <FontAwesomeIcon icon={faMapMarker} />
                                                    {siteObject && (siteObject.idAfa || siteObject.idObraAlfa || siteObject.idObra || siteObject.idobra) && (siteObject.idObra !== 'none' && siteObject.idobra !== 'none') && (
                                                        <span style={{ fontSize: '9px', marginTop: '2px', fontWeight: 'bold' }}>
                                                            {siteObject.idAfa || siteObject.idObraAlfa || siteObject.idObra || siteObject.idobra}
                                                        </span>
                                                    )}
                                                </div>
                                            </IconButton>
                                        )}
                                        {(admin ||
											isObserver ||
											isUniversalInspector ||
											isUniversalChief) && (
                                            <IconButton
                                                color={'primary'}
                                                style={{ marginRight: 5 }}
                                                edge={'end'}
                                                hidden={!hableCreateReport}
                                                onClick={() => setOpnKPI(true)}
                                                title="KPI"
                                            >
                                                <FontAwesomeIcon icon={faChartBar} />
                                            </IconButton>
                                        )}
                                        {admin && (
                                            <IconButton
                                                color={'primary'}
                                                style={{ marginRight: 5 }}
                                                edge={'end'}
                                                onClick={() => setOpenSpmDocuments(true)}
                                                title="Administración de Documentos SPM"
                                            >
                                                <FontAwesomeIcon icon={faFolderOpen} />
                                            </IconButton>
                                        )}
                                        <IconButton
                                            color={'primary'}
                                            style={{ marginRight: 5 }}
                                            edge={'end'}
                                            hidden={!hableCreateReport}
                                            onClick={openToReportSumary}
                                            title="Información de Reportes"
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                        </IconButton>
                                        <IconButton
                                            color={'primary'}
                                            style={{ marginRight: 5 }}
                                            edge={'end'}
                                            onClick={() => {
                                                navigate('/calendar')
                                            }}
                                            title="Calendario"
                                        >
                                            <FontAwesomeIcon icon={faCalendar} />
                                        </IconButton>
                                        <IconButton
                                            style={{ position: 'relative' }}
                                            color={'primary'}
                                            edge={'end'}
                                            hidden={!hableCreateReport}
                                            onClick={() => {
                                                navigate('/reports/create-report')
                                            }}
                                            title="Nuevo reporte"
                                        >
                                            <FontAwesomeIcon
                                                style={{
                                                    position: 'absolute',
                                                    zIndex: 100,
                                                    fontSize: 12,
                                                    top: 10,
                                                    right: 10,
                                                    color: '#F78E63',
                                                    fontWeight: 600
                                                }}
                                                icon={faPlus}
                                            />
                                            <FontAwesomeIcon
                                                style={{ zIndex: 10 }}
                                                icon={faClipboardList}
                                            />
                                        </IconButton>
                                    </Toolbar>
                                </div>
                            </div>
                        </Grid>
                        <Grid container>
                            {(admin ||
								isSapExecutive ||
								isShiftManager ||
								isChiefMachinery ||
								isOperatorInspector ||
								isObserver ||
								isUniversalInspector ||
								isUniversalChief) && (
                                <Grid item xs={12} sm={12} md={4} lg={'auto'} xl={'auto'}>
                                    <div className="menu-card">
                                        <h3>Inspecciones</h3>
                                        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                                            <List dense={true}>
                                                {inspecciones.map((e, i) => {
                                                    const accordionId = `Inspección-${e.name}`
                                                    return (
                                                        <div key={i}>
                                                            <ListItemButton
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    display: 'flex',
                                                                    fontSize: 10,
                                                                    borderRadius: 10,
                                                                    backgroundColor:
																		!isSearchingGlobal &&
																		(tipoReporteSeleccionado === e.name ||
																			(e.name === 'En proceso' &&
																				[
																				    'Ejecutando por operador',
																				    'Reasignar',
																				    'Revisión Supervisor',
																				    'Revisión J. Maquinaria'
																				].includes(tipoReporteSeleccionado))) &&
																		tipo === 'Inspección'
																		    ? '#ccc'
																		    : e.buttonColor || 'transparent'
                                                                }}
                                                                key={`button_${i}_inspecciones`}
                                                                id={`button_${i}_inspecciones`}
                                                                onClick={() => handleListClick(e, 'Inspección')}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faCircle}
                                                                    size="2x"
                                                                    style={{ marginRight: 10 }}
                                                                    color={e.color}
                                                                />
                                                                <ListItemText primary={e.name} />
                                                                <Chip
                                                                    label={e.number}
                                                                    size={'small'}
                                                                    style={{ width: 50 }}
                                                                />
                                                                {e.lista &&
																Object.values(e.lista).length > 0 ? (
                                                                        openAccordion === accordionId ? (
                                                                            <ExpandLess
                                                                                style={{
                                                                                    marginRight: 10,
                                                                                    marginLeft: 10
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <ExpandMore
                                                                                style={{
                                                                                    marginRight: 10,
                                                                                    marginLeft: 10
                                                                                }}
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                height: 24,
                                                                                width: 24,
                                                                                margin: '0px 10px'
                                                                            }}
                                                                        ></div>
                                                                    )}
                                                            </ListItemButton>
                                                            <Collapse
                                                                in={openAccordion === accordionId}
                                                                timeout="auto"
                                                                unmountOnExit
                                                            >
                                                                <List
                                                                    dense={true}
                                                                    style={{ marginLeft: 10 }}
                                                                    component="div"
                                                                    disablePadding
                                                                >
                                                                    {e.lista &&
																		Object.values(e.lista).map((object, n) => {
																		    const [key, value] =
																				Object.entries(object)[0]
																		    const isSelected =
																		        (tipoReporteSeleccionado === key ||
																		            subFilter === key) &&
																		        tipo === 'Inspección'
																		    return (
																		        <ListItemButton
																		            key={n}
																		            onClick={() => {
																		                filterState(
																		                    key,
																		                    'inspeccion',
																		                    e,
																		                    value
																		                )
																		            }}
																		            style={{
																		                cursor: 'pointer',
																		                borderRadius: 10,
																		                backgroundColor:
																							!isSearchingGlobal &&
																							(tipoReporteSeleccionado ===
																								key ||
																								subFilter === key) &&
																							tipo === 'Inspección'
																							    ? '#ccc'
																							    : 'transparent'
																		            }}
																		            sx={{ pl: 4 }}
																		        >
																		            <ListItemText primary={key} />
																		            <Chip
																		                label={value}
																		                size={'small'}
																		                style={{ width: 40, fontSize: 11 }}
																		            />
																		        </ListItemButton>
																		    )
																		})}
                                                                </List>
                                                            </Collapse>
                                                        </div>
                                                    )
                                                })}
                                            </List>
                                        </div>
                                    </div>
                                    {!isUniversalInspector && (
                                        <div className="menu-card">
                                            <h3>Mantenciones</h3>
                                            <div style={{ paddingLeft: 0, paddingRight: 10 }}>
                                                <List dense={true}>
                                                    {mantenciones.map((e, i) => {
                                                        const accordionId = `Mantención-${e.name}`
                                                        return (
                                                            <div key={i}>
                                                                <ListItemButton
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        fontSize: 10,
                                                                        borderRadius: 10,
                                                                        backgroundColor:
																			!isSearchingGlobal &&
																			(tipoReporteSeleccionado === e.name ||
																				(e.name === 'En proceso' &&
																					[
																					    'Ejecutando por operador',
																					    'Reasignar',
																					    'Revisión Supervisor',
																					    'Revisión J. Maquinaria'
																					].includes(
																					    tipoReporteSeleccionado
																					))) &&
																			tipo === 'Mantención'
																			    ? '#ccc'
																			    : e.buttonColor || 'transparent'
                                                                    }}
                                                                    key={`button_${i}_mantenciones`}
                                                                    id={`button_${i}_mantenciones`}
                                                                    onClick={() =>
                                                                        handleListClick(e, 'Mantención')
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={faCircle}
                                                                        size="2x"
                                                                        style={{ marginRight: 10 }}
                                                                        color={e.color}
                                                                    />
                                                                    <ListItemText primary={e.name} />
                                                                    <Chip
                                                                        label={e.number}
                                                                        size={'small'}
                                                                        style={{ width: 50 }}
                                                                    />
                                                                    {e.lista &&
																	Object.values(e.lista).length > 0 ? (
                                                                            openAccordion === accordionId ? (
                                                                                <ExpandLess
                                                                                    style={{
                                                                                        marginRight: 10,
                                                                                        marginLeft: 10
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <ExpandMore
                                                                                    style={{
                                                                                        marginRight: 10,
                                                                                        marginLeft: 10
                                                                                    }}
                                                                                />
                                                                            )
                                                                        ) : (
                                                                            <div
                                                                                style={{
                                                                                    height: 24,
                                                                                    width: 24,
                                                                                    margin: '0px 10px'
                                                                                }}
                                                                            ></div>
                                                                        )}
                                                                </ListItemButton>
                                                                <Collapse
                                                                    in={openAccordion === accordionId}
                                                                    timeout="auto"
                                                                    unmountOnExit
                                                                >
                                                                    <List
                                                                        dense={true}
                                                                        style={{ marginLeft: 10 }}
                                                                        component="div"
                                                                        disablePadding
                                                                    >
                                                                        {e.lista &&
																			Object.values(e.lista).map(
																			    (object, n) => {
																			        const [key, value] =
																						Object.entries(object)[0]
																			        const isSelected =
																						(tipoReporteSeleccionado === key ||
																							subFilter === key) &&
																						tipo === 'Mantención'
																			        return (
																			            <ListItemButton
																			                key={n}
																			                onClick={() => {
																			                    filterState(
																			                        key,
																			                        'mantencion',
																			                        e,
																			                        value
																			                    )
																			                }}
																			                style={{
																			                    cursor: 'pointer',
																			                    borderRadius: 10,
																			                    backgroundColor:
																									!isSearchingGlobal &&
																									(tipoReporteSeleccionado ===
																										key ||
																										subFilter === key) &&
																									tipo === 'Mantención'
																									    ? '#ccc'
																									    : 'transparent'
																			                }}
																			                sx={{ pl: 4 }}
																			            >
																			                <ListItemText primary={key} />
																			                <Chip
																			                    label={value}
																			                    size={'small'}
																			                    style={{
																			                        width: 40,
																			                        fontSize: 11
																			                    }}
																			                />
																			            </ListItemButton>
																			        )
																			    }
																			)}
                                                                    </List>
                                                                </Collapse>
                                                            </div>
                                                        )
                                                    })}
                                                </List>
                                            </div>
                                        </div>
                                    )}
                                </Grid>
                            )}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={
                                    admin ||
									isSapExecutive ||
									isShiftManager ||
									isChiefMachinery ||
									isOperatorInspector ||
									isObserver ||
									isUniversalInspector ||
									isUniversalChief
                                        ? 8
                                        : 12
                                }
                                lg={'auto'}
                                xl={'auto'}
                            >
                                <div
                                    style={{
                                        width:
											admin ||
											isSapExecutive ||
											isShiftManager ||
											isChiefMachinery ||
											isOperatorInspector ||
											isObserver ||
											isUniversalInspector ||
											isUniversalChief
											    ? 'calc(100vw - 350px)'
											    : '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 'calc(100vh - 190px)' // Adjusted height to fit pagination
                                    }}
                                >
                                    <div style={{ flexGrow: 1, overflow: 'hidden' }}>
                                        <ReportsList
                                            list={listToShow}
                                            typeReportsSelected={isSearchingGlobal ? 'all' : tipoReporteSeleccionado}
                                            statusReports={statusReports}
                                            getReports={getReports}
                                            tipo={isSearchingGlobal ? 'todos' : tipo}
                                            setAllItemsSelected={handleSelectAllItems}
                                            allItemsSelected={allItemsSelected}
                                            selectItem={selectItem}
                                            canSelect={admin || isSuperAdmin || isUniversalInspector}
                                        />
                                    </div>
                                    {listToShow && listToShow.length > 0 && (
                                        <div
                                            style={{
                                                padding: '10px 0',
                                                display: 'flex',
                                                justifyContent: 'flex-end'
                                            }}
                                        >
                                            <Pagination
                                                color={'primary'}
                                                count={totalPaginas}
                                                defaultPage={pagina}
                                                page={pagina}
                                                onChange={(e, page) => {
                                                    setPagina(page)
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>

            {/* Modal de confirmación para eliminar reportes */}
            <BulkActionDialog
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                onConfirm={confirmDelete}
                reports={Array.from(selectedReports.values())}
                onRemoveReport={handleRemoveSelectedReport}
                actionType="eliminar"
            />

            {/* Modal de confirmación para mover reportes a Origen */}
            <BulkActionDialog
                open={openMoveDialog}
                onClose={() => setOpenMoveDialog(false)}
                onConfirm={() => {
                    setOpenMoveDialog(false)
                    handleMoveToOrigen()
                }}
                reports={Array.from(selectedReports.values())}
                onRemoveReport={handleRemoveSelectedReport}
                actionType="mover"
            />
            {openSpmDocuments && (
                <SpmDocumentsDialog
                    open={openSpmDocuments}
                    handleClose={() => setOpenSpmDocuments(false)}
                />
            )}
        </Box>
    )
}

export default ReportsPage
